import { hideSpinner, showSpinner } from './../store/actions/spinners.actions';
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "../store/reducers";


@Injectable({
    providedIn: 'root'
})
export class LoadService {

    public isShowSpinner = false;

    constructor(public store: Store<AppState>) { }

    show() {
        this.isShowSpinner = true;
        this.store.dispatch(showSpinner());
    }

    hide() {
        this.isShowSpinner = false;
        this.store.dispatch(hideSpinner());
    }
}
